module.exports = __webpack_public_path__ + "img/fresh.a7586c7c.png";